<template>
  <div class="unsubscribes__table-part">
    <div
      class="cm-stat-table-container cm-stat-table-container--long"
      :style="{ width: `${width}px` }"
    >
      <h2
        v-if="title"
        class="cm-stat-table__title"
      >
        {{ title }}
      </h2>

      <div
        class="stat-header-search"
        :class="{ disabled: isLoading }"
      >
        <div class="stat-header-search__input">
          <input
            v-model="query"
            :placeholder="placeholder"
            type="text"
            @keyup.enter="initSearch"
            @keyup.delete="deleteSearch"
          >
          <button
            class="stat-header-search__clear"
            :class="{ 'stat-header-search__clear--show': isSearchQueryEmpty }"
            @click="clearSearch"
          >
            &#215;
          </button>
        </div>

        <Button
          skin="primary"
          :padding="30"
          @click.native="initSearch"
        >
          {{ $t(`campaign.statistics.find`) }}
        </Button>
      </div>

      <table class="cm-stat-table">
        <thead>
          <tr>
            <td
              v-for="(col, index) in cols"
              :key="index"
            >
              {{ col.label }}
            </td>
          </tr>
        </thead>

        <tbody
          v-if="isLoading"
          class="cm-stat-table__body--loading"
        >
          <tr>
            <td :colspan="keys.length">
              <spinner-dots :size="width / 5" />
            </td>
          </tr>
        </tbody>

        <tbody
          v-else-if="isError"
          class="cm-stat-table__body--error"
        >
          <tr>
            <td :colspan="keys.length">
              {{ $t(`campaign.statistics.errorWhileGettingData`) }}
            </td>
          </tr>
        </tbody>

        <tbody
          v-else-if="!tableData.length"
          class="cm-stat-table__body--empty"
        >
          <tr>
            <td :colspan="keys.length">
              {{ $t(`campaign.statistics.notFound`) }}
            </td>
          </tr>
        </tbody>

        <tbody
          v-else
          class="cm-stat-table__body"
        >
          <tr
            v-for="(row, index) in tableData"
            :key="index"
          >
            <td
              v-for="(td, tdIndex) in cols"
              :key="tdIndex"
              :class="td.className"
              v-html="td.format ? td.format(row[tdIndex]) : row[tdIndex]"
            />
          </tr>
        </tbody>
      </table>

      <CmPaginationNewTable
        v-if="filterCount > 10 && !isLoading"
        class="pagePagination"
        :count="filterCount"
        :visibilityBottomText="false"
        :activePage.sync="pageNumber"
        :countPerChunk="10"
        @update:activePage="changePage"
      />
    </div>
  </div>
</template>

<script>
import SpinnerDots from "@/manzana_library/components/Elements/SpinnerDots.vue";
import Button from "@/manzana_library/components/Elements/Button";
import CmPaginationNewTable from "@/components/library/CmPaginationNewTable.vue";
import { mapActions } from "vuex";

export default {
  components: {
    SpinnerDots,
    CmPaginationNewTable,
    Button,
  },

  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    longLinkTitle: {
      type: String,
      default: "Открыть всю таблицу",
    },
    value: {
      type: Array,
      default: () => [],
    },
    chunkSize: {
      type: Number,
      default: 10,
    },
    shortChunkSize: {
      type: Number,
      default: 3,
    },
    width: {
      type: Number,
      default: 670,
    },
    filterable: {
      type: Array,
    },
    sortable: {
      type: Array,
    },
    placeholder: {
      type: String,
      default: function () {
        return this.$t('general.enterName');
      },
    },
    tableLength: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      cols: {
        email: {
          label: this.$t(`campaign.statistics.subscriber`),
          className: "word-no-wrap",
        },
        date: {
          label: this.$t(`campaign.statistics.unsubscribeDate`),
          format: (d) => `${mt.tsToDate(d)} ${mt.tsToTime(d)}`,
        },
      },
      currentPage: 0,
    };
  },

  computed: {
    isSearchQueryEmpty() {
      return Boolean(this.query);
    },
    pageNumber: {
      get() {
        return this.$store.getters.unsubscribePageNumber;
      },
      set(val) {
        this.getUnsubscribePageNumber(val);
      },
    },
    filterCount() {
      const { total } = this.$store.getters.statUnsubscribe;
      return total;
    },
    keys() {
      return Object.keys(this.cols);
    },
    tableData() {
      return this.value;
    },
    query: {
      get() {
        return this.$store.getters.unsubscribeQuery;
      },
      set(val) {
        this.$store.commit("statMutation", { key: "unsubscribeQuery", value: val, parentKey: "data" });
      },
    },
  },

  mounted() {
    this.currentPage = this.pageNumber;
  },

  methods: {
    ...mapActions({
      getStatUnsubscribe: "getStatUnsubscribe",
      getUnsubscribePageNumber: "getUnsubscribePageNumber",
    }),
    initSearch() {
      this.pageNumber = 0;
      this.reloadFilters();
    },
    clearSearch() {
      this.query = "";
      this.pageNumber = 0;
      this.reloadFilters();
    },
    deleteSearch() {
      return !this.query && this.clearSearch();
    },

    changePage(value) {
      if (this.currentPage !== value) {
        this.currentPage = value;
        this.reloadFilters();
      }
    },
    reloadFilters() {
      const {
        params: { id },
        query: { taskid, launchid, stepid },
      } = this.$route;
      let sortArray = {
        page: this.pageNumber + 1,
        campuiid: id,
        taskid,
        launchid,
        stepid: stepid ? Number(stepid) : null,
        query: this.query,
      };
      this.getStatUnsubscribe(sortArray);
    },
  },
};
</script>

<style lang="scss">
.unsubscribes__table-part {
  width: fit-content;
}
</style>

<style lang="scss" scoped>
.cm-stat-table-container {
  .stat-header-search {
    display: flex;
    margin-right: 35px;
    margin-bottom: 20px;
    width: 45%;
    min-width: 470px;

    &__input {
      display: flex;
      width: 100%;
      max-width: 700px;
      margin-right: 10px;

      input {
        padding-right: 30px;
        width: 100%;
        min-width: 350px;
      }
    }

    &__clear {
      display: none;
      background: none;
      margin-left: -30px;
      margin-right: 10px;
      font-size: 25px;
      padding: 5px;
      width: 20px;

      &--show {
        display: block;
      }
    }

    &.disabled {
      opacity: 0.5;
      pointer-events: none;
    }
  }
}
</style>